import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { RECHARGE_STATUS_LABELS, RechargeHistoryStatus } from '../../types/recharge-history';
import styles from './RechargeStatusBadge.module.css';
export const RechargeStatusBadge = ({ status, size = 'medium', 'data-testid': testId, }) => {
    const { t } = useTranslation();
    const getStatusClass = (status) => {
        switch (status) {
            case RechargeHistoryStatus.PAYMENT_PENDING:
                return styles.statusPending;
            case RechargeHistoryStatus.RELEASING_CREDIT:
                return styles.statusReleasing;
            case RechargeHistoryStatus.CREDIT_RELEASED:
                return styles.statusReleased;
            case RechargeHistoryStatus.CANCELLED:
                return styles.statusCancelled;
            default:
                return styles.statusDefault;
        }
    };
    const getSizeClass = (size) => {
        switch (size) {
            case 'small':
                return styles.sizeSmall;
            case 'large':
                return styles.sizeLarge;
            case 'medium':
            default:
                return styles.sizeMedium;
        }
    };
    const statusLabel = t(RECHARGE_STATUS_LABELS[status]);
    return (_jsx("span", { className: `${styles.badge} ${getStatusClass(status)} ${getSizeClass(size)}`, "data-testid": testId, title: statusLabel, children: statusLabel }));
};
